module.exports = __webpack_public_path__ + "static/puffin-foundation-logo_small-ec972759bc216741ae9eecafdce5f087.png";